import React, { useEffect, useState } from "react";
import {
  Typography,
  IconButton,
  Card,
  CardActions,
  CardContent,
  Button,
  Grid,
} from "@mui/material";
import axios from "axios";
import RemoveCircleIcon from "@mui/icons-material/RemoveCircle";
import DeleteIcon from "@mui/icons-material/Delete";
import { useSetClass } from "../../globals/ClassContext";
import { useSetUser } from "../../globals/UserContext";
import { fetchClassAction } from "../../actions/fetchClass";
import { deleteClassAction } from "../../actions/deleteClass";

const { REACT_APP_DEBUGGER_SERVER_URL } = process.env;

export default function ClassCard(props) {
  const { classID } = props;
  const { setConfirmationEffect } = props;
  const { setConfirmationText } = props;
  const { handleConfirmationOpen } = props;

  const [singleClass, setSingleClass] = useState({});

  const setClass = useSetClass();
  const setUser = useSetUser();

  const handleClassOpen = (event) => {
    fetchClassAction(classID, setClass);
    props.isTeacher ? props.setPage("adminInfo") : props.setPage("classInfo");
  };

  const handleRemove = (event) => {
    // Setting a state to a function must be done with an argument-less anonymous function to work
    setConfirmationText(
      <span>
        <b>Permanently delete</b> this class? This cannot be undone.
      </span>
    );
    setConfirmationEffect(() => deleteAssignment);
    // } else {
    //   setConfirmationText("Would you like to remove "+ singleClass.name +" from your class list?")
    //   setConfirmationEffect(() => removeAssignment);
    // }
    handleConfirmationOpen();
    // event.stopPropagation();
  };

  const deleteAssignment = () => {
    deleteClassAction(classID, setUser);
  };

  useEffect(() => {
    async function fetchClass() {
      const res = await axios
        .get(`${REACT_APP_DEBUGGER_SERVER_URL}/classes/${classID}`)
        .catch((error) => {
          console.log(error);
        });
      setSingleClass(res.data);
    }
    fetchClass();
  }, [classID]);

  return (
    <Grid key={classID} item xs={3} sx={{ marginTop: "30px" }}>
      <Card
        sx={{ marginBottom: "20px", marginLeft: "10px", marginRight: "10px" }}
      >
        <CardContent>
          <Typography sx={{ fontSize: 20 }} color="text.secondary" gutterBottom align="left">
            {singleClass.name}
          </Typography>
          <Typography sx={{ fontSize: 14 }} color="text.secondary" gutterBottom>
            {"Teacher: " + singleClass.teacherName}
          </Typography>
        </CardContent>
        
        <CardActions>
          <>
            <Button variant="outlined" size="small" onClick={handleClassOpen}>
              Open Class
            </Button>
          </>
          {props.isTeacher ? (
            <IconButton
              color="primary"
              arialabel="remove"
              onClick={handleRemove}
            >
              {typeof classID === "undefined" ? (
                <DeleteIcon />
              ) : (
                <RemoveCircleIcon />
              )}
            </IconButton>
          ) : null}
        </CardActions>
      </Card>
    </Grid>
  );
}
